module.exports = __webpack_public_path__ + "img/logo.0b9879f7.webp";